var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.componentVisible)?_c('div',{staticClass:"machine-counter-wrapper not-ready"},[_c('hr'),_vm._v(" Noch "+_vm._s(_vm.numberToWord[_vm.pagesToFinish])),_c('br'),_vm._v("bis zum Zwischenergebnis ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }